import { render, staticRenderFns } from "./signBank.vue?vue&type=template&id=72b6f6a8"
import script from "./signBank.vue?vue&type=script&lang=js"
export * from "./signBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports